function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "45px",
    viewBox: "0 0 50 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 38.419998,
    y1: 44.540001,
    x2: 38.419998,
    y2: 0.48,
    gradientTransform: "matrix(0.99272,0,0,0.99272,0.182,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(20%,36.078431%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(1.176471%,90.980392%,86.27451%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 11.58,
    y1: 44.540001,
    x2: 11.58,
    y2: 0.48,
    gradientTransform: "matrix(0.99272,0,0,0.99272,0.182,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(20%,36.078431%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(1.176471%,90.980392%,86.27451%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 49.203125 17.957031 L 35.730469 17.957031 C 34.339844 17.957031 33.648438 16.28125 34.628906 15.296875 L 43.207031 6.722656 C 43.445312 6.484375 43.445312 6.085938 43.207031 5.847656 L 37.539062 0.179688 C 37.300781 -0.0585938 36.902344 -0.0585938 36.664062 0.179688 L 28.1875 8.65625 C 26.378906 10.464844 26.371094 13.402344 28.1875 15.207031 L 32.933594 19.953125 C 34.339844 21.363281 34.339844 23.636719 32.933594 25.046875 L 28.1875 29.792969 C 26.378906 31.609375 26.378906 34.535156 28.1875 36.34375 L 36.664062 44.820312 C 36.902344 45.058594 37.300781 45.058594 37.539062 44.820312 L 43.207031 39.152344 C 43.445312 38.914062 43.445312 38.515625 43.207031 38.277344 L 34.628906 29.703125 C 33.648438 28.71875 34.339844 27.042969 35.730469 27.042969 L 49.203125 27.042969 C 49.539062 27.042969 49.816406 26.765625 49.816406 26.425781 L 49.816406 18.5625 C 49.816406 18.226562 49.539062 17.949219 49.203125 17.949219 Z M 49.203125 17.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 0.796875 17.957031 L 14.269531 17.957031 C 15.660156 17.957031 16.351562 16.28125 15.371094 15.296875 L 6.792969 6.722656 C 6.554688 6.484375 6.554688 6.085938 6.792969 5.847656 L 12.460938 0.179688 C 12.699219 -0.0585938 13.097656 -0.0585938 13.335938 0.179688 L 21.8125 8.65625 C 23.621094 10.464844 23.628906 13.402344 21.8125 15.207031 L 17.066406 19.953125 C 15.660156 21.363281 15.660156 23.636719 17.066406 25.046875 L 21.8125 29.792969 C 23.621094 31.609375 23.621094 34.535156 21.8125 36.34375 L 13.335938 44.820312 C 13.097656 45.058594 12.699219 45.058594 12.460938 44.820312 L 6.792969 39.152344 C 6.554688 38.914062 6.554688 38.515625 6.792969 38.277344 L 15.371094 29.703125 C 16.351562 28.71875 15.660156 27.042969 14.269531 27.042969 L 0.796875 27.042969 C 0.460938 27.042969 0.183594 26.765625 0.183594 26.425781 L 0.183594 18.5625 C 0.183594 18.226562 0.460938 17.949219 0.796875 17.949219 Z M 0.796875 17.957031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2S);
export default __webpack_public_path__ + "static/media/2s.ea3ccf871a27b0ba500c7939ce25c871.svg";
export { ForwardRef as ReactComponent };